// AuthContext.jsx
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from './firebaseapi'
import { fetchUserDetailsRequest, RESET_USER } from '../redux/modules/auth/action'
import { PORTAL_USER_TYPES } from '@common/src/constants/constants'
import BootScreen from '../components/common/pageLoader/bootScreen'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch()
  const { user, companies = [], permission = [], loading } = useSelector((state) => state.auth)
  const [currentUser, setCurrentUser] = useState(null)
  const [type, setType] = useState(null)
  const [authInitialized, setAuthInitialized] = useState(false)

  useEffect(() => {
    setType(user?.userType)
    setCurrentUser(user?.userType)
  }, [user, companies, permission])

  const contextValue = useMemo(
    () => ({ currentUser, permission, type, loading, authInitialized }),
    [currentUser, permission, type, loading, authInitialized]
  )
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setAuthInitialized(true)
      if (!user) {
        dispatch({ type: RESET_USER })
        return
      }
      if (user?.uid && auth?.currentUser) {
        const idTokenResult = await auth.currentUser.getIdTokenResult(true)
        const customClaims = idTokenResult?.claims
        if (PORTAL_USER_TYPES[import.meta.env.VITE_PORTAL]?.includes(customClaims.userType)) {
          dispatch(fetchUserDetailsRequest(user.uid))
        }
      }
    })
    return () => unsubscribe()
  }, [])
  if (!authInitialized) {
    return <BootScreen />
  }
  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
}

export const useAuth = () => useContext(AuthContext)
